import Error from "./Error.vue";
export default Error;
